import React from 'react';
import { FaEdit } from "react-icons/fa";

function IconButton({
    text,onclick,children,disabled,outline = false,
    customClasses,
    type
}) {
    return (
        <button className={`${customClasses}`} disabled={disabled} onClick={onclick}
        type={type}>
            {
                children ? (
                    <>
                        <span>
                            {text}
                        </span>
                        {children}
                    </>
                ) : (
                    <span>{text} </span>
                )
            }
        </button>
    );
}

export default IconButton;